import { useEffect, useCallback } from 'react';
import { Spritesheet } from 'pixi.js';
import { useSpritesStore } from '../store/spritesSlice';
import { bundleLoaderService } from '../services/BundleLoaderService';

export const useSpritesLoader = () => {
  const { textures, isLoaded, setIsLoaded } = useSpritesStore();

  const loadSprites = useCallback(async () => {
    await bundleLoaderService.ensureBundle('core');
    await bundleLoaderService.ensureBundle('hub');
    setIsLoaded(true);
  }, [setIsLoaded]);

  useEffect(() => {
    if (!isLoaded) {
      loadSprites();
    }
  }, [isLoaded, loadSprites]);

  const getSprite = useCallback(
    (name: string): Spritesheet | undefined => textures[name],
    [textures],
  );

  return { textures, isLoaded, loadSprites, getSprite };
};
